import React from 'react';
import './InvoiceTemplate.css';

const InvoiceTemplate = React.forwardRef(({ invoice, customer, company }, ref) => {
  const invoiceDate = invoice.invoice_date 
    ? new Date(invoice.invoice_date).toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })
    : new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' });
  
  const dueDate = invoice.due_date 
    ? new Date(invoice.due_date).toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })
    : '';

  return (
    <div ref={ref} className="invoma-invoice">
      {/* Header */}
      <div className="invoice-header-top">
        <div className="header-logo-section">
          {company.logo && <img src={company.logo} alt="Company Logo" className="company-logo" />}
        </div>
        <div className="header-title-section">
          <h1 className="invoice-heading">INVOICE</h1>
        </div>
      </div>

      {/* Invoice Number & Date */}
      <div className="invoice-meta-top">
        <div className="meta-box">
          <label>Invoice No</label>
          <p>#{invoice.invoice_number || `INV-${invoice.id}`}</p>
        </div>
        <div className="meta-box">
          <label>Date</label>
          <p>{invoiceDate}</p>
        </div>
        {dueDate && (
          <div className="meta-box">
            <label>Due Date</label>
            <p>{dueDate}</p>
          </div>
        )}
      </div>

      {/* Invoice To & Pay To */}
      <div className="billing-info">
        <div className="bill-section">
          <h3>Invoice To</h3>
          <div className="bill-content">
            <p className="name-bold">{customer.name}</p>
            {customer.address && <p>{customer.address}</p>}
            {customer.city && (
              <p>
                {customer.city}
                {customer.state && `, ${customer.state}`}
                {customer.postal_code && ` ${customer.postal_code}`}
              </p>
            )}
            {customer.country && <p>{customer.country}</p>}
            {customer.email && <p>{customer.email}</p>}
          </div>
        </div>

        <div className="bill-section">
          <h3>Pay To</h3>
          <div className="bill-content">
            <p className="name-bold">{company.company || 'Your Company'}</p>
            {company.address && <p>{company.address}</p>}
            {company.city && (
              <p>
                {company.city}
                {company.state && `, ${company.state}`}
                {company.zipCode && ` ${company.zipCode}`}
              </p>
            )}
            {company.email && <p>{company.email}</p>}
          </div>
        </div>
      </div>

      {/* Items Table */}
      <table className="items-table-detailed">
        <thead>
          <tr>
            <th className="col-item">#</th>
            <th className="col-description">Description</th>
            <th className="col-price">Unit Price</th>
            <th className="col-qty">Quantity</th>
            <th className="col-amount">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="col-item">1</td>
            <td className="col-description">{invoice.description || 'Professional Services'}</td>
            <td className="col-price">₹{parseFloat(invoice.subtotal || invoice.amount).toFixed(2)}</td>
            <td className="col-qty">1</td>
            <td className="col-amount">₹{parseFloat(invoice.subtotal || invoice.amount).toFixed(2)}</td>
          </tr>
        </tbody>
      </table>

      {/* Payment Info */}
      {invoice.payment_terms && (
        <div className="payment-info-section">
          <h3>Payment Info:</h3>
          <p className="payment-detail">{invoice.payment_terms}</p>
        </div>
      )}

      {/* Totals */}
      <div className="totals-section-detailed">
        <div className="totals-box">
          <div className="total-row">
            <span>Subtotal</span>
            <span>₹{parseFloat(invoice.subtotal || invoice.amount).toFixed(2)}</span>
          </div>
          {invoice.tax_total && parseFloat(invoice.tax_total) > 0 && (
            <div className="total-row">
              <span>Tax ({invoice.tax_percentage || 0}%)</span>
              <span>+₹{parseFloat(invoice.tax_total).toFixed(2)}</span>
            </div>
          )}
          <div className="total-row grand-total">
            <strong>Grand Total</strong>
            <strong>₹{parseFloat(invoice.total_amount || invoice.amount).toFixed(2)}</strong>
          </div>
        </div>
      </div>

      {/* Terms & Conditions */}
      {invoice.notes && (
        <div className="terms-section">
          <h3>Terms & Conditions:</h3>
          <div className="terms-content">
            {invoice.notes}
          </div>
        </div>
      )}

      {/* Footer */}
      <div className="invoice-footer-section">
        <p>Thank you for your business!</p>
      </div>
    </div>
  );
});

InvoiceTemplate.displayName = 'InvoiceTemplate';

export default InvoiceTemplate;
